import React from 'react'
import { Controller, useFormContext } from 'react-hook-form'
import { useIntl } from 'react-intl'

import s from './styles.module.scss'

import SeasonMonthButton from './components/SeasonMonthButton'
import {
  HouseSeasonalBusynessCalendar,
  HouseSeasonalBusynessCalendarMonths,
  SeasonEnum,
} from '../../../../../../../../lib/graphql'
import { monthDefaultMessages } from '../../../../../../../../utils/month/constants'

interface HouseSeasonalBusynessCalendarMonthElementProps {
  month: {
    label: string
    value: keyof Omit<HouseSeasonalBusynessCalendarMonths, '__typename'>
  }
  disabled: boolean
}
const HouseSeasonalBusynessCalendarMonthElement = ({
  month,
  disabled,
}: HouseSeasonalBusynessCalendarMonthElementProps) => {
  const seasons: SeasonEnum[] = Object.values(SeasonEnum)

  const handleOnClick = (season: SeasonEnum): SeasonEnum => {
    return seasons[(seasons.indexOf(season) + 1) % seasons.length]
  }

  const { control } = useFormContext<HouseSeasonalBusynessCalendar[]>()

  return (
    <div>
      <span>{month.label}</span>

      <Controller
        control={control}
        render={({ field }) => {
          return (
            <SeasonMonthButton
              className={s.seasonMonthButton}
              startSeason={field.value.firstHalf}
              endSeason={field.value.secondHalf}
              {...(!disabled && {
                onStartClick: () =>
                  field.onChange({
                    ...field.value,
                    firstHalf: handleOnClick(field.value.firstHalf),
                  }),
                onEndClick: () =>
                  field.onChange({
                    ...field.value,
                    secondHalf: handleOnClick(field.value.secondHalf),
                  }),
              })}
            />
          )
        }}
        name={`0.months.${month.value}`}
      />
    </div>
  )
}

const shortenMonthLabel = (month: string): string => {
  return month.length > 4 ? month.substring(0, 4) + '.' : month
}

const HouseSeasonalBusynessCalendarMonthsGrid = ({
  disabled,
}: {
  disabled: boolean
}) => {
  const intl = useIntl()

  return (
    <div className={s.seasonsMonthCalendar}>
      <div className={s.row}>
        <HouseSeasonalBusynessCalendarMonthElement
          month={{
            label: shortenMonthLabel(
              intl.formatMessage(monthDefaultMessages.january),
            ),
            value: 'january',
          }}
          disabled={disabled}
        />
        <HouseSeasonalBusynessCalendarMonthElement
          month={{
            label: shortenMonthLabel(
              intl.formatMessage(monthDefaultMessages.february),
            ),
            value: 'february',
          }}
          disabled={disabled}
        />
        <HouseSeasonalBusynessCalendarMonthElement
          month={{
            label: shortenMonthLabel(
              intl.formatMessage(monthDefaultMessages.march),
            ),
            value: 'march',
          }}
          disabled={disabled}
        />
        <HouseSeasonalBusynessCalendarMonthElement
          month={{
            label: shortenMonthLabel(
              intl.formatMessage(monthDefaultMessages.april),
            ),
            value: 'april',
          }}
          disabled={disabled}
        />
      </div>
      <div className={s.row}>
        <HouseSeasonalBusynessCalendarMonthElement
          month={{
            label: shortenMonthLabel(
              intl.formatMessage(monthDefaultMessages.may),
            ),
            value: 'may',
          }}
          disabled={disabled}
        />
        <HouseSeasonalBusynessCalendarMonthElement
          month={{
            label: shortenMonthLabel(
              intl.formatMessage(monthDefaultMessages.june),
            ),
            value: 'june',
          }}
          disabled={disabled}
        />
        <HouseSeasonalBusynessCalendarMonthElement
          month={{
            label: shortenMonthLabel(
              intl.formatMessage(monthDefaultMessages.july),
            ),
            value: 'july',
          }}
          disabled={disabled}
        />
        <HouseSeasonalBusynessCalendarMonthElement
          month={{
            label: shortenMonthLabel(
              intl.formatMessage(monthDefaultMessages.august),
            ),
            value: 'august',
          }}
          disabled={disabled}
        />
      </div>
      <div className={s.row}>
        <HouseSeasonalBusynessCalendarMonthElement
          month={{
            label: shortenMonthLabel(
              intl.formatMessage(monthDefaultMessages.september),
            ),
            value: 'september',
          }}
          disabled={disabled}
        />
        <HouseSeasonalBusynessCalendarMonthElement
          month={{
            label: shortenMonthLabel(
              intl.formatMessage(monthDefaultMessages.october),
            ),
            value: 'october',
          }}
          disabled={disabled}
        />
        <HouseSeasonalBusynessCalendarMonthElement
          month={{
            label: shortenMonthLabel(
              intl.formatMessage(monthDefaultMessages.november),
            ),
            value: 'november',
          }}
          disabled={disabled}
        />
        <HouseSeasonalBusynessCalendarMonthElement
          month={{
            label: shortenMonthLabel(
              intl.formatMessage(monthDefaultMessages.december),
            ),
            value: 'december',
          }}
          disabled={disabled}
        />
      </div>
    </div>
  )
}

export default HouseSeasonalBusynessCalendarMonthsGrid
